/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch, Redirect } from 'react-router-dom';
import { includes, toLower } from 'lodash';
import App from '@pages/app';
import AuthorizedRoute from '@components/AuthorizedRoute/AuthorizedRoute';
import { setCookie } from '@utils/cookie-methods';

const Auth = Loadable({
  loader: () => import('@pages/auth'),
  loading: () => <div />,
});

const Search = Loadable({
  loader: () => import('@pages/search'),
  loading: () => <div />,
});

const DirectOffers = Loadable({
  loader: () => import('@pages/direct-offers'),
  loading: () => <div />,
});

const CarrierProfile = Loadable({
  loader: () => import('@pages/profile'),
  loading: () => <div />,
});

export const getRoutes = () => {
  const { pathname, search } = window.location;
  if (!includes(pathname, '/auth')) {
    setCookie('defaultRoute', toLower(`${pathname}${search}`), 10);
  }

  return (
    <App>
      <Switch>
        <Route path="/auth" render={props => <Auth {...props} />} />
        <Route
          path="/d"
          render={props => <DirectOffers {...props} isWhiteListed />}
        />
        <AuthorizedRoute
          path="/search"
          render={props => <Search {...props} />}
        />
        <AuthorizedRoute
          path="/manage/profile"
          render={props => <CarrierProfile {...props} />}
        />
        <AuthorizedRoute
          path="/direct"
          render={props => <DirectOffers {...props} />}
        />
        <Redirect to="/search" />
      </Switch>
    </App>
  );
};
